"use client";

import EngineDateTable from "@/components/vrat/EngineDateTable";
import type { CalendarPradoshItem } from "@/lib/api/calendar";

export interface PradoshYearData {
  year: number;
  pradoshas: CalendarPradoshItem[];
}

function paksha(item: CalendarPradoshItem): string {
  return item.name_hi.includes("शुक्ल") ? "Shukla" : "Krishna";
}

export default function PradoshDates({ years }: { years: PradoshYearData[] }) {
  return (
    <EngineDateTable
      years={years.map(({ year, pradoshas }) => ({ year, entries: pradoshas }))}
      tabLabel="Pradosh"
      itemHeader="Pradosh"
      detailHeader="Paksha"
      detail={paksha}
      emptyMessage="Pradosh Vrat dates are computed live from the Vedic engine. The schedule could not be loaded right now — please refresh in a moment to see every Trayodashi date."
      footer="All Pradosh dates are computed from real planetary positions using the Swiss Ephemeris engine with Lahiri Ayanamsa — Trayodashi tithi boundary, not a fixed calendar."
    />
  );
}
